import axios from "axios";
import { REACT_APP_WUCA_DXP_ADMIN_URL } from "./config";
import { logger } from "./logger";

const API_URL = `${REACT_APP_WUCA_DXP_ADMIN_URL}api/v1/localization/all`;
let localizationData: Record<string, string> = sessionStorage.getItem("localizationWUCAData") ? JSON.parse(sessionStorage.getItem("localizationWUCAData") || "{}") : {} ;
let isLocalizationDataLoaded = false;
let initializationPromise: Promise<void> | null = null;
let intervalId: NodeJS.Timeout | null = null;

// Export the refresh function - simplified without re-authentication
async function refreshLocalizationIndex(): Promise<void> {
  let retries = 2;
  while (retries >= 0) {
    try {
      const response = await axios.get(API_URL, {
        headers: {
          'accept': 'text/plain',
        },
      });
     
      localizationData = response.data.localizations;
      sessionStorage.setItem("localizationWUCAData", response.data.localizations ? JSON.stringify(response.data.localizations) : "{}");
      isLocalizationDataLoaded = true;
      return; // Success, exit
    } catch (error: any) {
      console.info("Failed to refresh localization data:", error);
      logger.logToApi({
        type: "Error",
        source: "LocalizationService",
        eventCode: "FETCH_LOCALIZATION_API_ERROR",
        error: `${error}`,
      });
      
      retries--;
      if (retries >= 0) {
        await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second
      }
    }
  }
}

// Initialize localization service
export async function initializeLocalizationService(): Promise<void> {
  // Return existing promise if initialization is in progress
  if (initializationPromise) {
    return initializationPromise;
  }

  // Skip if already loaded
  if (isLocalizationDataLoaded) {
    return Promise.resolve();
  }

  initializationPromise = refreshLocalizationIndex();
  await initializationPromise;
  initializationPromise = null;
  
  // Set up interval for periodic refresh only if data was successfully loaded
  if (isLocalizationDataLoaded && !intervalId) {
    intervalId = setInterval(refreshLocalizationIndex, 60 * 60 * 1000);
  }
}

// Synchronous helper to get localized values
export function getLocalizedValueSync(key: string): string | null {
  return isLocalizationDataLoaded || sessionStorage.getItem("localizationWUCAData") ? localizationData[key] || key : key;
}

// Test helper function to reset state
export function __resetLocalizationState(): void {
  localizationData = {};
  isLocalizationDataLoaded = false;
  initializationPromise = null;
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}